import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reduxForm, Form } from 'redux-form';

import AddressForm from 'common/components/address/AddressForm';
import {
  transformAddressData,
  initialFormValues
} from 'common/components/address/helpers';
import { FormError } from 'common/components/layout';
import { getDefaultCountryCode, removeSpaces } from 'common/helpers/miscHelper';
import {
  integerFormat,
  convertStringToInteger
} from 'common/helpers/numberHelper';
import CreditCardForm from 'profile/creditCard/components/CreditCardForm';
import { updateAndProcessReservationCart } from 'redux/reservationCart/actions';

import { requiresCreditCard } from '../helpers';

import {
  validateAddressForNotLoggedInCustomer,
  validateCreditCard
} from './validators';

class Payment extends Component {
  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form, this.props);
    const reservationCart = {
      creditCard: data.creditCard,
      billTo: data.address
    };
    const successFunction = (reservation) => {
      props.history.push(
        `/reservation/checkout/receipt?reservationNumber=${
          reservation.reservationNumber
        }&email=${encodeURIComponent(props.reservationCart.data.email)}`
      );
    };
    props.updateAndProcessReservationCart(reservationCart, successFunction);
  };

  handleBack = (e) => {
    const { props } = this;
    e.preventDefault();
    props.onEdit('customer');
  };

  render() {
    const { reservationCart, handleSubmit, change, form, settings } =
      this.props;
    let object = { countryCode: getDefaultCountryCode(settings) };
    if (reservationCart.billTo) {
      object = reservationCart.billTo;
    }
    const showCreditCard = requiresCreditCard(reservationCart.data);
    return (
      <Form
        onSubmit={handleSubmit(this.handleSubmit)}
        className="c7-form"
        method="post"
      >
        <FormError formName={form} />
        {showCreditCard && (
          <>
            <h3>Payment method</h3>
            <p>All transactions are secure and encrypted.</p>
            <CreditCardForm />
            <p>&nbsp;</p>
          </>
        )}

        {showCreditCard && <h3>Billing address</h3>}
        {!showCreditCard && <h3>Your address</h3>}
        <AddressForm
          object={object}
          changeFunction={change}
          settings={settings}
        />

        <div className="c7-checkout__content__buttons">
          <button type="submit" className="c7-button">
            Complete Reservation
          </button>
          <a onClick={this.handleBack}>Return to customer information</a>
        </div>
      </Form>
    );
  }
}

const transformData = (values, props) => {
  const address = transformAddressData(values);
  let creditCard;
  address.customerAddressId = values.customerAddressId;
  if (requiresCreditCard(props.reservationCart.data)) {
    creditCard = {
      cardNumber: values.cardNumber && removeSpaces(values.cardNumber),
      expiryMo: values.expiryMo && integerFormat(values.expiryMo),
      expiryYr: values.expiryYr && integerFormat(values.expiryYr),
      cvv2: values.cvv2,
      cardHolderName: values.cardHolderName
    };
  }
  return { address, creditCard };
};

const validate = (values, props) => {
  let errors = {};
  const { address } = transformData(values, props);
  address.birthDay = values.birthDay && convertStringToInteger(values.birthDay);
  address.birthMonth =
    values.birthMonth && convertStringToInteger(values.birthMonth);
  address.birthYear =
    values.birthYear && convertStringToInteger(values.birthYear);
  errors = Object.assign(
    errors,
    validateAddressForNotLoggedInCustomer(address, props.settings)
  );
  if (requiresCreditCard(props.reservationCart.data)) {
    const { creditCard } = transformData(values, props);
    errors = Object.assign(errors, validateCreditCard(creditCard));
  }
  return errors;
};

const mapStateToProps = (state) => {
  const reservationCart = state.reservationCart.data;
  let initialValues = {};
  if (reservationCart) {
    const { billTo } = reservationCart;
    initialValues = Object.assign(initialValues, initialFormValues(billTo));
  }
  if (!initialValues.countryCode) {
    initialValues.countryCode = getDefaultCountryCode(state.setting);
  }
  return {
    reservationCart: state.reservationCart,
    settings: state.setting,
    initialValues
  };
};

Payment = reduxForm({
  form: 'paymentNotLoggedInPickup',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(Payment);

export default withRouter(
  connect(mapStateToProps, { updateAndProcessReservationCart })(Payment)
);
